
import CoreFormElementInputBase from './BaseInput';
import { CoreFormElementProps } from '../../interfaces/';
import { FORM_ELEMENT_PROPS, INPUT_TYPE_WEEK } from '../../constants/';
import { HashMapMergeProps } from '../../../../../utils/';

/**
 * Week Input Element
 * @export
 * @class CoreFormElementWeek
 * @extends {CoreFormElementInputBase}
 */
export default class CoreFormElementWeek extends CoreFormElementInputBase {
  /**
   * Default Props
   * @static
   * @type {Omit<CoreFormElementProps, 'name'>}
   * @memberof CoreFormElementWeek
   */
  public static defaultProps: Omit<CoreFormElementProps, 'name'> = HashMapMergeProps(FORM_ELEMENT_PROPS, {
    type: INPUT_TYPE_WEEK,
    placeholder: 'yyyy-W(0)w',
    pattern: '[0-9]{4}-W([0-9]{2}|0[0-9]{1})'
  });
}
